import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NewSideBarAdmin } from '../../NewSideBarAdmin';
import GetClientlById from '../../../Services/Admin/GetClientById';
import { ClientInfo } from '../../../Modeles/Client';
import profil from "../IMG/defaultProfil.png";
import "./CommercialInformation.css";

export interface ClientType {
  Client: ClientInfo[];
  messageErrosClient: string;
}

export default function ClientInformation() {
  const { id, idMag } = useParams();
  const [loading, setLoading] = useState(true);

  const [stateClient, setstateClient] = useState<ClientType>({
    Client: [] as ClientInfo[],
    messageErrosClient: "Aucun client",
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const clientRes = await GetClientlById(id, idMag).GetClient();
        setstateClient((prev) => ({ ...prev, Client: clientRes.data }));
      } catch (error) {
        console.error("Error fetching client data:", error);
      }

      setLoading(false);
    };

    fetchData();
  }, [id, idMag]);

  const { Client } = stateClient;

  return (
    <div className="cpi-wrapper">
      <NewSideBarAdmin />

      {loading ? (
        <div className="cpi-main">
          <div className="cpi-loading">
            <div className="cpi-spinner" role="status"></div>
            <span className="cpi-loading-text">Chargement...</span>
          </div>
        </div>
      ) : (
        <div className="cpi-main">
          <div className="cpi-page-header">
            <button
              className="cpi-back-btn"
              onClick={() => window.history.back()}
              aria-label="Retour"
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <div>
              <span className="cpi-eyebrow">Espace Admin</span>
              <h1 className="cpi-page-title">Profil du Client</h1>
              <p className="cpi-page-subtitle">Gérez les informations de ce client</p>
            </div>
          </div>

          <div className="cpi-content">
            <InformationsGénerale client={Client} />
            <CommandesAssociées />
          </div>
        </div>
      )}
    </div>
  );
}

// Information Component
const InformationsGénerale: React.FC<{ client: ClientInfo[] }> = ({ client }) => {
  const [showPassword, setShowPassword] = useState(false);

  if (!client || client.length === 0) {
    return (
      <section className="cpi-card cpi-fade-in">
        <div className="cpi-empty-wrap">
          <div className="cpi-empty-state">
            <i className="bi bi-inbox"></i>
            <p>Aucun client trouvé</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      {client.map((item, index) => (
        <div key={index} className="cpi-fade-in">
          {/* Hero / identity panel */}
          <div className="cpi-hero">
            <div className="cpi-hero-glow"></div>

            <div className="cpi-hero-main">
              <img src={profil} alt="Profile" className="cpi-avatar" />
              <div className="cpi-hero-id">
                <span className="cpi-role-tag">
                  <i className="bi bi-person-badge-fill"></i> Client
                </span>
                <h2>{item.NomClient} {item.PrenomClient}</h2>
                <span className="cpi-status-pill">
                  <i className="bi bi-circle-fill"></i> Actif
                </span>
              </div>
            </div>

            <div className="cpi-hero-stats">
              <div className="cpi-stat">
                <span className="cpi-stat-label">
                  <i className="bi bi-wallet2"></i> Solde
                </span>
                <span className="cpi-stat-value">
                  {item.credit || 0}<small>MAD</small>
                </span>
              </div>
              <div className="cpi-stat-divider"></div>
              <div className="cpi-stat">
                <span className="cpi-stat-label">
                  <i className="bi bi-percent"></i> Remise
                </span>
                <span className="cpi-stat-value">
                  {item.RemiseGlobal || 0}<small>%</small>
                </span>
              </div>
            </div>
          </div>

          {/* Coordonnées */}
          <p className="cpi-section-label">Coordonnées</p>
          <div className="cpi-details-grid">
            <div className="cpi-detail-card">
              <div className="cpi-detail-icon">
                <i className="bi bi-envelope-fill"></i>
              </div>
              <div className="cpi-detail-content">
                <label>Email</label>
                <p>{item.Email}</p>
              </div>
            </div>

            <div className="cpi-detail-card">
              <div className="cpi-detail-icon">
                <i className="bi bi-telephone-fill"></i>
              </div>
              <div className="cpi-detail-content">
                <label>Téléphone</label>
                <p>{item.Tele}</p>
              </div>
            </div>

            <div className="cpi-detail-card">
              <div className="cpi-detail-icon">
                <i className="bi bi-lock-fill"></i>
              </div>
              <div className="cpi-detail-content cpi-detail-content-row">
                <div>
                  <label>Mot de passe</label>
                  <p>{showPassword ? item.Password : "••••••••"}</p>
                </div>
                <button
                  className="cpi-eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
                </button>
              </div>
            </div>
          </div>

          {/* Danger zone */}
          <div className="cpi-danger-zone">
            <div>
              <h4>Supprimer ce client</h4>
              <p>Cette action est irréversible et supprimera définitivement le compte.</p>
            </div>
            <button className="cpi-btn-danger">
              <i className="bi bi-trash-fill"></i>
              Supprimer
            </button>
          </div>
        </div>
      ))}
    </>
  );
};

// Orders Component
const CommandesAssociées: React.FC = () => {
  return (
    <section className="cpi-card cpi-fade-in">
      <div className="cpi-card-header">
        <div>
          <h3>Commandes associées</h3>
          <p className="cpi-card-subtitle">Historique des commandes</p>
        </div>
      </div>

      <div className="cpi-empty-state">
        <i className="bi bi-receipt"></i>
        <p>Aucune commande associée pour le moment</p>
      </div>
    </section>
  );
};